import { EventEmitter } from '@angular/core';
import { HttpService } from 'gast-common-ng';
import { UrlService } from './common/url.service';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "gast-common-ng";
import * as i2 from "@angular/common/http";
import * as i3 from "./common/url.service";
var OnsetService = /** @class */ (function () {
    function OnsetService(httpService, http, urlService) {
        this.httpService = httpService;
        this.http = http;
        this.urlService = urlService;
        this.checkTanCompleted = new EventEmitter();
        this.bookingMappingLoaded = new EventEmitter();
        this.bookingMappingSaved = new EventEmitter();
        this.bookingStudyLoaded = new EventEmitter();
        this.checkIfEnoughMobileParticipantDone = new EventEmitter();
    }
    OnsetService.prototype.createBookingMappingForBooking = function (bookingDto, username) {
        var _this = this;
        var callback = function (found) {
            _this.bookingMappingSaved.emit(found);
        };
        var errorCallback = function (error) {
            console.log(' cannot save booking mapping');
        };
        var url = this.urlService.createOnsetBookingForOnsetStudy(username);
        var request = {
            method: 'POST',
            mapper: function (response) { return response.json(); },
            callback: callback,
            body: bookingDto,
            url: url
        };
        this.http.post(url, bookingDto, { withCredentials: true, responseType: 'json' })
            .subscribe(callback, errorCallback);
    };
    OnsetService.prototype.createOnsetBookingStudy = function () {
        var _this = this;
        var callback = function (found) {
            _this.bookingStudyLoaded.emit(found);
        };
        var errorCallback = function (error) {
            console.log(' cannot create onset booking for study');
        };
        var url = this.urlService.createGastBookingForOnsetStudy();
        var request = {
            method: 'POST',
            mapper: function (response) { return response.json(); },
            callback: callback,
            body: null,
            url: url
        };
        this.httpService.post(request, errorCallback);
    };
    OnsetService.prototype.checkIfEnoughMobileParticipantForOnsetStudy = function () {
        var _this = this;
        var successCallback = function (result) {
            var booleanValue = result == 'true' ? true : false;
            _this.checkIfEnoughMobileParticipantDone.emit(booleanValue);
        };
        var errorCallback = function (error) {
            console.log(error);
        };
        var url = this.urlService.checkIfAlreadyEnoughParticipantForMobileVersion();
        this.http.get(url, { withCredentials: true, responseType: 'text' })
            .subscribe(successCallback, errorCallback);
    };
    OnsetService.ngInjectableDef = i0.defineInjectable({ factory: function OnsetService_Factory() { return new OnsetService(i0.inject(i1.HttpService), i0.inject(i2.HttpClient), i0.inject(i3.UrlService)); }, token: OnsetService, providedIn: "root" });
    return OnsetService;
}());
export { OnsetService };
